import { Chip, FormControlLabel, Switch } from '@mui/material'
import React from 'react'
import { formatDate } from '../../utils/helpers'

const AccountActivity = ({user, setStatusDialogOpen, getDaysSinceJoined}) => {
  return (
    <div className="space-y-6">
              <h3 className="text-lg font-semibold mb-4 text-secondary-900">
                Account Timeline
              </h3>
              <div className="space-y-4">
                <div className="flex justify-between py-2 border-b">
                  <span className="text-secondary-600">Date Joined</span>
                  <span className="font-medium">
                    {formatDate(user.date_joined)}
                  </span>
                </div>
                <div className="flex justify-between py-2 border-b">
                  <span className="text-secondary-600">Last Login</span>
                  <span className="font-medium">
                    {formatDate(user.last_login)}
                  </span>
                </div>
                <div className="flex justify-between py-2 border-b">
                  <span className="text-secondary-600">Days as Member</span>
                  <span className="font-medium">
                    {getDaysSinceJoined()} days
                  </span>
                </div>
                <div className="flex justify-between py-2 border-b">
                  <span className="text-secondary-600">Account Status</span>
                  <div className="flex items-center space-x-2">
                    <Chip
                      label={user.is_active ? "Active" : "Inactive"}
                      color={user.is_active ? "success" : "default"}
                      size="small"
                    />
                    <FormControlLabel
                      control={
                        <Switch
                          checked={user.is_active}
                          onChange={() => setStatusDialogOpen(true)}
                          color="primary"
                        />
                      }
                      label=""
                    />
                  </div>
                </div>
              </div>
            </div>
  )
}

export default AccountActivity